import { IconNameV1 } from 'common/icon/iconV1.js';
import { StatusAccess } from 'utilities/status/status-access.js';

export interface IAccessState {
  label: string;
  icon: IconNameV1;
  // backgroundClass: string;
  textClass: string;
}

const closed: IAccessState = {
  label: 'Closed',
  icon: 'closed' as IconNameV1,
  // backgroundClass: 'status-bad',
  textClass: 'u-textRed',
};
const open: IAccessState = {
  label: 'Open',
  icon: 'open' as IconNameV1,
  // backgroundClass: 'status-good',
  textClass: 'u-textGreen',
};
const paused: IAccessState = {
  label: 'On Hold',
  icon: 'paused' as IconNameV1,
  // backgroundClass: 'status-medium',
  textClass: 'u-textOrange',
};
const caution: IAccessState = {
  label: 'On Hold',
  icon: 'caution' as IconNameV1,
  // backgroundClass: 'status-medium',
  textClass: 'u-textOrange',
};
const DEFAULT: IAccessState = {
  label: '',
  icon: '' as IconNameV1,
  textClass: 'u-textBlue',
};

export function getAccessStatus(status: StatusAccess): IAccessState {
  switch (status) {
    case StatusAccess.Open:
      return open;
    case StatusAccess.Paused:
      return paused;
    case StatusAccess.Caution:
      return caution;
    case StatusAccess.Default:
      return DEFAULT;
    case StatusAccess.Closed:
    default:
      return closed;
  }
}
